<template>
  <FormattedMessage
    v-if="provider"
    class="text-static-default-low caption"
    :definition="translations.providerInfo"
    tag="p"
  >
    <template #provider>
      <RevLink
        class="caption !text-static-default-low"
        :to="provider.link"
        target="_blank"
      >
        {{ i18n(provider.name) }}
      </RevLink>
    </template>
  </FormattedMessage>
</template>

<script setup lang="ts">
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevLink } from '@ds/components/Link'

import translations from './TradeInProviderInfo.translations'

interface Provider {
  name: I18nDefinition
  link: string
}

const i18n = useI18n()
const { countryCode } = useMarketplace().market

const tradeInProviders: Partial<Record<MarketCountryCode, Provider>> = {
  [MarketCountryCode.AU]: {
    name: translations.providerNameAu,
    link: 'https://www.renewablemobile.com.au/',
  },
  [MarketCountryCode.JP]: {
    name: translations.providerNameJp,
    link: 'https://belong.co.jp/',
  },
}
const provider = tradeInProviders[countryCode]
</script>
